export class CanalePagamento {
	id: number;
	comune_id: number;
	ente: string;
	coordinate: string;
	descrizione: string;

	constructor(id: any = null){
		this.id = id;
		this.clear();
	}
	
	clear(){
		this.comune_id = null;
		this.ente = '';
		this.coordinate = '';
		this.descrizione = '';
	}
}
